"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sabbioneta": {
    "54c843d1": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "skipSearch": false
    }],
    "ca-d-amici": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6cb2a7f8": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "skipSearch": false
    }],
    "cantonazzo-foa": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2b093973": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "skipSearch": false
    }],
    "colombare": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b19a13b0": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "skipSearch": false
    }],
    "lago-i": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "928b86c6": [{
      "hkey": "51e9088c",
      "slug": "san-remigio",
      "name": "San Remigio",
      "primary": true,
      "skipSearch": false
    }],
    "mezzana-san-remigio": [{
      "hkey": "51e9088c",
      "slug": "san-remigio",
      "name": "San Remigio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "08ef10a6": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "skipSearch": false
    }],
    "ronchi": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "485ba4e0": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "skipSearch": false
    }],
    "sabbioncelli": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "49adc4f3": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "skipSearch": false
    }],
    "viazzola": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "96253c2e": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "skipSearch": false
    }],
    "vigoreto": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "458e2c05": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "skipSearch": false
    }],
    "villa-sacca": [{
      "hkey": "8150ac65",
      "slug": "sabbioneta",
      "name": "Sabbioneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;